import React from 'react';
import { X } from 'lucide-react';
import WebStepShell from './WebStepShell';
import type { WebFlowCtx } from './types';

interface Props {
  ctx: WebFlowCtx;
}

const Step6Failed: React.FC<Props> = ({ ctx }) => (
  <WebStepShell
    step="failed"
    onHeaderBack={ctx.openExitModal}
    onCancel={ctx.openExitModal}
    secondary={{ label: 'Back', onClick: () => ctx.goTo('wificonf') }}
    primary={{ label: 'Retry', onClick: () => ctx.goTo('wificonf') }}
    media={
      <div className="dcfw-image-source">
        <div className="dcfw-device-wrap">
          <picture>
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.avif`}
              type="image/avif"
            />
            <img
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.webp`}
              alt="SmartEco IAQ device"
              className="dcf-illustration"
            />
          </picture>

          <picture className="dcfw-indicator">
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/all-failed-indicator.avif`}
              type="image/avif"
            />
            <img
              src={`${process.env.PUBLIC_URL}/DeviceSetup/all-failed-indicator.webp`}
              alt="Device indicator lights showing failure"
              className="dcfw-indicator-image"
            />
          </picture>

          <div
            className="dcf-status-icon dcfw-check-badge dcf-status-icon--danger"
            aria-hidden="true"
          >
            <X strokeWidth={2} />
          </div>
        </div>
      </div>
    }
  >
    <p className="dcfw-eyebrow">SETUP PHASE 6</p>
    <h2 className="dcfw-title">Step 6 of 6: Device not connected</h2>

    <span className="dcf-step-subtitle live dcf-step-subtitle--danger">
      Device is Inactive
    </span>
    <p className="dcf-step-subtitle">
      Your Smart Eco device is offline. Please follow the below steps
      properly to get the device active and then &lsquo;retry&rsquo;.
    </p>

    <ol className="dcf-info-list dcf-info-list--numbered" style={{ marginTop: 8 }}>
      <li className="dcf-info-list__item">
        <span className="dcf-info-list__num">1</span>
        You were connected to &ldquo;IAQ_{ctx.serialNumber}&rdquo; during set-up
      </li>
      <li className="dcf-info-list__item">
        <span className="dcf-info-list__num">2</span>
        Your Wi-Fi name and password are correct
      </li>
      <li className="dcf-info-list__item">
        <span className="dcf-info-list__num">3</span>
        <span>Device must be connected with <strong>2.4GHz only</strong></span>
      </li>
    </ol>
  </WebStepShell>
);

export default Step6Failed;
